import {RequestStatus} from "../../../request";

export interface EventsState {
  report: CohortReport | null;
  fetchCohortReportRequestState: RequestStatus;
}

export const initialState: EventsState = {
  report: null,

  fetchCohortReportRequestState: {
    isLoading: false,
    isSuccessful: false,
    isFailed: false,
  }
};

export function Events(state = initialState, action: any) {
  switch (action.type) {
    case "events-update-request-state":
      return {
        ...state,
        fetchCohortReportRequestState: action.requestState,
      };
    case "events-update-report":
      return {
        ...state,
        report: action.report,
      };
    case "reset-data":
      return initialState;
    default:
      return state;
  }
}

export interface CohortRow {
  "campaignId": number,
  "campaignName": string,
  "eventName": string,
  "installs": number,
  "spend": number,
  "eventsD0": number,
  "eventsD1": number,
  "eventsD3": number,
  "eventsD7": number,
  "eventsD14": number,
  "eventsD30": number
  "eventsD60": number
  "eventsD180": number
  "revenueD0": number,
  "revenueD1": number,
  "revenueD3": number,
  "revenueD7": number,
  "revenueD14": number,
  "revenueD30": number
  "revenueD60": number
  "revenueD180": number
}

export interface CohortReport {
  from: Date,
  until: Date,
  rows: CohortRow[];
}
